import { render, staticRenderFns } from "./UnidadeFilterBar.vue?vue&type=template&id=4e49058f"
import script from "./UnidadeFilterBar.vue?vue&type=script&lang=js"
export * from "./UnidadeFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports